export const userRoles = [
  { label: 'Customer', value: 'CUSTOMER' },
  { label: 'Agent', value: 'AGENT' },
  { label: 'Admin', value: 'ADMIN' },
];

export const accountTypes = [
  { label: 'Regular', value: 'REGULAR' },
  { label: 'Money Transfers', value: 'MONEY' },
  { label: 'Super Admin', value: 'PARCELS' },
  { label: 'Supervisor', value: 'SUPERVISOR' },
  { label: 'picker', value: 'PICKER' },
  { label: 'Admin', value: 'MONEYCOMP' },
  { label: 'Admin', value: 'GUEST' },
];
